export default __webpack_public_path__ + "static/media/banner.8388ab0b.svg";